
export default class ExcelModule {

    public static ExportTo(elements: any[], sheetName: string, fileName: string): void {

        try {
            import('xlsx').then((xlsx: any) => {
                const worksheet = xlsx.utils.json_to_sheet(elements);
                const workbook = { Sheets: { [sheetName]: worksheet }, SheetNames: [sheetName] };
                const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
                ExcelModule.SaveAsFile(excelBuffer, fileName);
            });
        } catch (error) {
            console.log(error);
        }
    }

    public static ImportFrom(e: any, callback: any): void {

        try {
            const file = e.files[0];

            import('xlsx').then((xlsx: any) => {
                const reader = new FileReader();

                reader.onload = (e: any) => {
                    const workbook = xlsx.read(e.target.result, { type: 'array'});
                    const worksheetName = workbook.SheetNames[0];
                    const worksheet = workbook.Sheets[worksheetName];
                    const data = xlsx.utils.sheet_to_json(worksheet, { header: 1, raw: false});

                    const cols = data[0];
                    data.shift();

                    let dataRead = data.map((d: any) => {
                        return cols.reduce((obj: any, c: any, i: any) => {
                            obj[c] = d[i];
                            return obj;
                        }, {});
                    });

                    callback(dataRead);
                }

                reader.readAsArrayBuffer(file);
            });

        } catch (error) {
            console.log(error);
        }
    }


    private static SaveAsFile(buffer: any, fileName: string): void {

        try {
            import('file-saver').then((FileSaver: any) => {
                let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
                let EXCEL_EXTENSION = '.xlsx';

                const data = new Blob([buffer], {
                    type: EXCEL_TYPE
                });

                FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
            })
        } catch (error) {
            console.log(error);
        }
    }
}